import {FCResourceType} from './resourceKnowledgeTool.enums';
import {FCResource, ResourceKnowledgeConfig} from './resourceKnowledgeTool.types';
import {dspResourceConfig} from 'common/src/modules/adServingPartner/copilot/adServingPartner.config';

const resourceKnowledgeConfigs: Record<FCResourceType, ResourceKnowledgeConfig<FCResource>> = {
  [FCResourceType.DSP]: dspResourceConfig,
};

export {resourceKnowledgeConfigs};
